import { html } from 'lit'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'

import styles from './style.scss'
import zeroFinancingBadge from './zeroFinancingBadge'

interface CheckoutLearnMoreProps {
  mainText?: string
  ctaLabel?: string
  ctaLink?: string
  ctaLinkTextInLabel?: string
  theme?: string
  locale: string
  zeroInterestBadgeText?: string
  onLearnMoreClick: () => null
  buyersProtectionLabel?: string
  buyersProtectionLink?: string
  onBuyersProtectionClick?: (e: Event) => void
}

export default function checkout(props: CheckoutLearnMoreProps) {
  const {
    onLearnMoreClick,
    locale,
    mainText,
    ctaLabel = '',
    ctaLink = '',
    ctaLinkTextInLabel = '',
    theme,
    zeroInterestBadgeText,
    buyersProtectionLabel,
    buyersProtectionLink,
    onBuyersProtectionClick,
  } = props

  let ctaLinkTag = `<a id="checkout-cta-link" class="checkout-cta-link" href="${ctaLink}" role="button">${ctaLabel}</a>`

  const ctaLinkPosition = ctaLabel?.indexOf(ctaLinkTextInLabel)
  if (ctaLinkTextInLabel && ctaLinkPosition !== -1) {
    const partBefore = ctaLabel.slice(0, ctaLinkPosition)
    const partAfter = ctaLabel.slice(ctaLinkPosition + ctaLinkTextInLabel.length)
    ctaLinkTag =
      partBefore +
      `<a id="checkout-cta-link" class="checkout-cta-link" href="${ctaLink}" role="button">` +
      ctaLinkTextInLabel +
      '</a>' +
      partAfter
  }

  let buyersProtectionLinkTag = ''
  if (buyersProtectionLabel && buyersProtectionLink && mainText) {
    buyersProtectionLinkTag = `<a class="checkout-buyers-protection-link" target="_blank" rel="noopener noreferrer" href="${buyersProtectionLink}">${buyersProtectionLabel}</a>`

    const buyersProtectionLabelPosition = mainText.indexOf(buyersProtectionLabel)
    const before = mainText.slice(0, buyersProtectionLabelPosition)
    const after = mainText.slice(buyersProtectionLabelPosition + buyersProtectionLabel.length)
    buyersProtectionLinkTag = before + buyersProtectionLinkTag + after
  }

  return html`
    <style>
      ${styles}
    </style>
    <div
      data-testid="checkout"
      class="${locale} checkout-container ${theme}"
      part="osm-checkout-container"
      aria-label="Checkout Information"
      role="region"
    >
      ${
        zeroInterestBadgeText
          ? html` <div class="checkout-zero-financing">
              ${zeroFinancingBadge()} ${zeroInterestBadgeText}
            </div>`
          : ''
      }
      ${zeroInterestBadgeText ? html`<div class="vertical-space"></div>` : ''}
      <div class="checkmark-flex-container">
        <div class="checkout-main-text ${theme}" role="heading" aria-level="2" @click=${onBuyersProtectionClick}>
          <span> ${unsafeHTML(buyersProtectionLinkTag)} </span>
        </div>
        <div
          class="checkout-text-info"
          @click=${onLearnMoreClick}
          aria-labelledby="checkout-cta-link"
        >
          <span> ${unsafeHTML(ctaLinkTag)} </span>
          </span>
        </div>
      </div>
    </div>
  `
}
